import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

export const useCanAccessCommunicationsDashboardsDigitalSafetyPage = () => {
  const isDigitalSafetyPageEnabled = useExperimentTreatmentWithoutReporting('DigitalSafety') === true;

  return isDigitalSafetyPageEnabled;
};
